// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DmkfumCthJs6jwfDeNT4{flex-grow:1;width:100%;display:flex;position:relative}.UEvkD9GSv6UBCdIehopr{align-items:center;min-width:0;min-height:80px;display:flex}.puZGxF6nMAgbJzGtdLhJ{align-items:center;gap:8px;display:flex}.LylCzCl_8EiuLhI5pLby{margin-right:8px}.yv0HC5SYTssutb2DPpou{grid-template-columns:1fr auto;display:grid}.yv0HC5SYTssutb2DPpou>div:first-child{text-overflow:ellipsis;min-width:0;display:inline;overflow:hidden}.LylCzCl_8EiuLhI5pLby.jjV5TBhrGJAhe5J4XKgq{--interaction-neutral-normal:var(--custom-cherry-blaze);--interaction-neutral-hovered:var(--custom-cherry-blaze)}.aQi1JbSXP8cdR4omsiaA{width:calc(100% - 6px);height:100%}.D4OSn4lbcYQMA4iTMIEU{pointer-events:none}.D4OSn4lbcYQMA4iTMIEU tbody{opacity:.4}.qU1iJyOXTSwRN4wGfIgL{--dropdown-checked-margin-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `DmkfumCthJs6jwfDeNT4`,
	"row": `UEvkD9GSv6UBCdIehopr`,
	"headerCell": `puZGxF6nMAgbJzGtdLhJ`,
	"select": `LylCzCl_8EiuLhI5pLby`,
	"selectBtn": `yv0HC5SYTssutb2DPpou`,
	"error": `jjV5TBhrGJAhe5J4XKgq`,
	"viewScrollClassName": `aQi1JbSXP8cdR4omsiaA`,
	"loading": `D4OSn4lbcYQMA4iTMIEU`,
	"dropdown": `qU1iJyOXTSwRN4wGfIgL`
};
export default ___CSS_LOADER_EXPORT___;
